import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Emitter } from '@fullcalendar/core/internal';

@Component({
    selector: 'app-rappel-item',
    templateUrl: './rappel-item.component.html',
    imports: [CommonModule,],
    styleUrls: ['./rappel-item.component.css']
})
export class RappelItemComponent {
  @Input('myColor1') myColor1:any;
  @Input('myColor2') myColor2:any;
  @Input('data') data:any=[];
  @Output('selectedEventEmitter') selectedEventEmitter:EventEmitter<any> = new EventEmitter();


 hexToRgb(hex:any) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}

setSelected(el:any){
this.selectedEventEmitter.emit(el)
}
}
